module.exports = __webpack_public_path__ + "img/esite_logo.7ea4c679.png";